import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { SignaturePlacementDto } from "@/core/features/employee-document-categories/signature-placement.dto";
import { Type } from "class-transformer";

export class EmployeeDocumentCategoryTemplateVersionDto extends BaseEntityDto {
  templateId: string;
  versionNumber: number;
  storageKey: string;
  filename: string;
  mimetype: string;
  size: number;
  contentHash: string;

  @Type(() => SignaturePlacementDto)
  placements?: SignaturePlacementDto[];
}
